import { amplitudeLib } from 'freedom-shared';

import {
  mainPageOpen,
  submitSearchForm,
  switchCitiesClick,
  blogClick,
  ticketPageClick,
  mainScroll,
  multiTripToggleClick,
  multiTripAutoExit,
  multiTripInfoOpen,
  multiTripSubmitValidationFailed,
  getMainPageVariant,
  aiChatOpen,
  mainPageLayoutAssigned,
} from './main-page';
import {
  searchPageOpen,
  priceCalendarClick,
  filtersClick,
  resetFiltersClick,
  applyFiltersClick,
  sortSeparateClick,
  airlinesSeparateClick,
  timeSeparateClick,
  transfersSeparateClick,
  airlinesSeparateApplied,
  timeSeparateApplied,
  transfersSeparateApplied,
  directSeparateClick,
  directSeparateApplied,
  changeSortMode,
  directFlightsClick,
  directFlightsShowMore,
  directFlightsView,
  openChangeSearchParams,
  priceCalendarShow,
  priceSwipeRight,
  priceSwipeLeft,
  priceCalendarClose,
  priceCalendarOffersShow,
  serpScroll,
  promocodeApplied,
  shareButtonClicked,
  searchResultCardCashbackPriceClick,
} from './search-page';
import {
  quizBannerClick,
  quizPageViewed,
  quizQuestion,
  quizNextQuestion,
  quizFinal,
  takePromocodeClick,
  otherRoutesClick,
} from './quiz';
import {
  detailsPageOpen,
  detailsPageContinue,
  jjDetailsBannerShow,
} from './details-page';
import {
  bookingSuccess,
  bookingError,
  productsPageOpen,
  priceChangeGuardShown,
  priceChangeGuardContinue,
  priceChangeGuardCancel,
} from './products-page';
import {
  selectFareFamily,
  continueFareFamily,
  fareFamilyHintClick,
} from './fare-family';
import {
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersScroll,
  hotOffersSearchClick,
  hotOffersPageOpen,
} from './hot-offers';
import {
  trySubmitPassengersData,
  selectSavedPassenger,
  savedPaxListOpen,
  savedPaxEditClick,
  savedPaxSaveClick,
  addNewPaxClick,
} from './passenger-data-page';
import {
  specialOffersBannerOpened,
  allSpecialOffersPageOpened,
  specialOffersClicked,
  specialOfferFriendsShown,
  specialOfferFriendsClicked,
} from './special-offers';
import {
  lastSearchesShow,
  lastSearchesClick,
  lastSearchesRemove,
} from './recent-searches';
import {
  mainTabClicked,
  favoritesTabClicked,
  ordersTabClicked,
  profileTabClicked,
} from './bottom-nav';
import {
  addToFavorites,
  removeFromFavorites,
  favoritesPageOpen,
  favoritesDirectionOpen,
  favoritesOfferClick,
  favoritesSearchClick,
} from './favorites';
import {
  bookingPageOpen,
  bookingPassengerSaved,
  bookingPayClick,
  bookingFallback,
  type QuickBookingFlow,
} from './quick-booking';
import {
  recommendedOffersShown,
  recommendedOffersTriggerClick,
  recommendedOffersTeaserClick,
  recommendedOffersListItemClick,
} from './recommended-offers';
import { priceChangeShown, priceChangeClosed } from './payment-page';
import {
  getFactoringVariant,
  factoringMethodShown,
  paymentMethodChanged,
  factoringTermSelected,
  factoringDocsShown,
  factoringDocsConfirmed,
  factoringStart,
  factoringOtpSent,
  factoringOtpError,
  factoringSigned,
  factoringPrescoringResult,
  factoringPrescoringContinue,
  factoringScoringApproved,
  factoringScoringRejected,
  factoringBankRedirect,
  factoringResultShown,
  factoringError,
} from './factoring';
import {
  nomadLabelClick,
  milesCardBlockShow,
  milesCardBlockClick,
  milesCardAddClick,
  milesCardSaved,
  milesCardDeleted,
  milesCardSelected,
} from './miles-cards';
import {
  aviaTourPromoOfferShown,
  aviaTourPromoOfferClicked,
} from './avia-tour-promo';
import {
  aiChatClose,
  aiChatMessageSent,
  aiChatReplyChipsShown,
  aiChatRetryClick,
  aiChatTurnStop,
  aiChatDatePickerShown,
  aiChatDatesPicked,
  aiChatDiscoverStart,
  aiChatDiscoverStep,
  aiChatDiscoverResultsShown,
  aiChatDiscoverRegenerate,
  aiChatDiscoverRestart,
  aiChatDestinationSelect,
  aiChatOfferShown,
  aiChatOfferSelect,
  aiChatFareShown,
  aiChatFareSelect,
  aiChatPassengersShown,
  aiChatPassengersConfirm,
  aiChatPaymentCardShown,
  aiChatPaymentStart,
  aiChatBookingCancel,
  aiChatPaymentResult,
  aiChatTicketIssued,
  aiChatHotelOffersShown,
  aiChatHotelSelect,
  aiChatEventCardShown,
  aiChatEventCardSelect,
  aiChatError,
  aiChatHistoryOpen,
  aiChatSessionNew,
  aiChatSessionSwitch,
  aiChatTripPlanOpen,
  aiChatTripPlanSave,
} from './ai-chat';

export type {
  MultiTripToggleDirection,
  MultiTripValidationErrorCode,
  MainPageVariant,
  AiChatOpenSource,
} from './main-page';

export type {
  AiChatFunnelStage,
  AiChatMessageContext,
  AiChatDiscoverTrigger,
  AiChatDiscoverStepType,
  AiChatErrorStage,
} from './ai-chat';

export type { QuickBookingFlow } from './quick-booking';

export type { MilesCardAddSource } from './miles-cards';

export type { PriceChangeParams } from './payment-page';

export type {
  FactoringContext,
  FactoringErrorStage,
  FactoringOtpErrorReason,
  FactoringPrescoringOutcome,
  FactoringMethodChangeParams,
  FactoringTermSelectedParams,
  FactoringEventParams,
  FactoringStartParams,
  FactoringRejectedParams,
  FactoringErrorParams,
  FactoringOtpSentParams,
  FactoringOtpErrorParams,
  FactoringPrescoringResultParams,
  FactoringScoringApprovedParams,
  FactoringResultShownParams,
} from './factoring';

/**
 * Контекст оплаты для `avfree_payment_click`. Без него клик по кнопке оплаты
 * неотличим для карты и рассрочки, а на этом клике и расходится воронка:
 * карта уходит в нативную оплату, рассрочка — в факторинг.
 */
type PaymentClickContext = {
  payment_method: string;
  installment_term?: number;
};

const paymentClick = (
  promocodeSum?: string | null,
  isCharter?: boolean,
  flow: QuickBookingFlow = 'classic',
  paymentContext?: PaymentClickContext,
) => {
  amplitudeLib.logEvent('avfree_payment_click', {
    promocode_sum: promocodeSum,
    is_charter: isCharter,
    main_page_variant: getMainPageVariant(),
    flow,
    payment_method: paymentContext?.payment_method ?? 'card',
    installment_term: paymentContext?.installment_term,
    factoring_variant: getFactoringVariant(),
  });
};

export const amplitudeEventsLib = {
  mainPageOpen,
  aiChatOpen,
  submitSearchForm,
  searchPageOpen,
  detailsPageOpen,
  detailsPageContinue,
  jjDetailsBannerShow,
  selectFareFamily,
  continueFareFamily,
  fareFamilyHintClick,
  selectSavedPassenger,
  trySubmitPassengersData,
  bookingError,
  bookingSuccess,
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersScroll,
  hotOffersPageOpen,
  hotOffersSearchClick,
  changeSortMode,
  switchCitiesClick,
  blogClick,
  priceCalendarClick,
  filtersClick,
  resetFiltersClick,
  applyFiltersClick,
  sortSeparateClick,
  airlinesSeparateClick,
  timeSeparateClick,
  transfersSeparateClick,
  airlinesSeparateApplied,
  timeSeparateApplied,
  transfersSeparateApplied,
  directSeparateClick,
  directSeparateApplied,
  savedPaxListOpen,
  savedPaxEditClick,
  savedPaxSaveClick,
  addNewPaxClick,
  productsPageOpen,
  priceChangeGuardShown,
  priceChangeGuardContinue,
  priceChangeGuardCancel,
  paymentClick,
  specialOffersBannerOpened,
  allSpecialOffersPageOpened,
  specialOffersClicked,
  specialOfferFriendsShown,
  specialOfferFriendsClicked,
  ticketPageClick,
  quizBannerClick,
  quizPageViewed,
  quizQuestion,
  quizNextQuestion,
  quizFinal,
  takePromocodeClick,
  otherRoutesClick,
  directFlightsClick,
  directFlightsShowMore,
  directFlightsView,
  openChangeSearchParams,
  priceCalendarShow,
  priceSwipeRight,
  priceSwipeLeft,
  priceCalendarClose,
  priceCalendarOffersShow,
  serpScroll,
  promocodeApplied,
  lastSearchesShow,
  lastSearchesClick,
  lastSearchesRemove,
  shareButtonClicked,
  searchResultCardCashbackPriceClick,
  mainScroll,
  addToFavorites,
  removeFromFavorites,
  favoritesPageOpen,
  favoritesDirectionOpen,
  favoritesOfferClick,
  favoritesSearchClick,
  mainTabClicked,
  favoritesTabClicked,
  ordersTabClicked,
  profileTabClicked,
  bookingPageOpen,
  bookingPassengerSaved,
  bookingPayClick,
  bookingFallback,
  multiTripToggleClick,
  multiTripAutoExit,
  multiTripInfoOpen,
  multiTripSubmitValidationFailed,
  mainPageLayoutAssigned,
  recommendedOffersShown,
  recommendedOffersTriggerClick,
  recommendedOffersTeaserClick,
  recommendedOffersListItemClick,
  priceChangeShown,
  priceChangeClosed,
  getFactoringVariant,
  factoringMethodShown,
  paymentMethodChanged,
  factoringTermSelected,
  factoringDocsShown,
  factoringDocsConfirmed,
  factoringStart,
  factoringOtpSent,
  factoringOtpError,
  factoringSigned,
  factoringPrescoringResult,
  factoringPrescoringContinue,
  factoringScoringApproved,
  factoringScoringRejected,
  factoringBankRedirect,
  factoringResultShown,
  factoringError,
  nomadLabelClick,
  milesCardBlockShow,
  milesCardBlockClick,
  milesCardAddClick,
  milesCardSaved,
  milesCardDeleted,
  milesCardSelected,
  aiChatClose,
  aiChatMessageSent,
  aiChatReplyChipsShown,
  aiChatRetryClick,
  aiChatTurnStop,
  aiChatDatePickerShown,
  aiChatDatesPicked,
  aiChatDiscoverStart,
  aiChatDiscoverStep,
  aiChatDiscoverResultsShown,
  aiChatDiscoverRegenerate,
  aiChatDiscoverRestart,
  aiChatDestinationSelect,
  aiChatOfferShown,
  aiChatOfferSelect,
  aiChatFareShown,
  aiChatFareSelect,
  aiChatPassengersShown,
  aiChatPassengersConfirm,
  aiChatPaymentCardShown,
  aiChatPaymentStart,
  aiChatBookingCancel,
  aiChatPaymentResult,
  aiChatTicketIssued,
  aiChatHotelOffersShown,
  aiChatHotelSelect,
  aiChatEventCardShown,
  aiChatEventCardSelect,
  aiChatError,
  aiChatHistoryOpen,
  aiChatSessionNew,
  aiChatSessionSwitch,
  aiChatTripPlanOpen,
  aiChatTripPlanSave,
  aviaTourPromoOfferShown,
  aviaTourPromoOfferClicked,
};
